<template>
  <section class="container" id="directory">
    <div class="content-view">
      <div class="section">
        <h2>Créditos</h2>
        <div class="columns">
          <!-- COLUMNA DE DIRECTORIO DE ADMINISTRATIVOS -->
          <div class="column is-hidden-mobile is-hidden-tablet-only">
            <div class="columns is-centered">
              <div class="column is-two-thirds is-full-mobile">
                <article class="panel">
                  <p class="panel-heading primary-background">
                    2022
                  </p>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="has-text-weight-bold">Directora General</p>
                        <p class="">Biól. María Dolores Valle Martínez</p>
                      </div>
                    </div>
                  </div>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="has-text-weight-bold">Secretaría General</p>
                        <p class="">Lic. Jaime Cortés Vite</p>
                      </div>
                    </div>
                  </div>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="has-text-weight-bold">Secretaría Académica</p>
                        <p class="">M. en C. María Josefina Segura Gortares</p>
                      </div>
                    </div>
                  </div>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="has-text-weight-bold">Jefatura de la UIAP</p>
                        <p class="">Lic. José Luis Castillo Jordan</p>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
          <!-- FIN DE COLUMNA DE DIRECTORIO DE ADMINISTRATIVOS -->

          <!-- COLUMNA REAL DE CRÉDITOS -->
          <div class="column">
            <!-- Inicio del panel Revisor de información -->
            <div class="columns is-centered">
              <div class="column is-two-thirds is-full-mobile">
                <article class="panel">
                  <p class="panel-heading primary-background">
                    Gestión de información
                  </p>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="">Lic. José Luis Castillo Jordan</p>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
            <!-- Fin del panel Revisor de información -->
            <!-- Inicio del panel Generación de contenidos -->
            <div class="columns is-centered">
              <div class="column is-two-thirds is-full-mobile">
                <article class="panel">
                  <p class="panel-heading primary-background">
                    Información
                  </p>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="">Lic. María del Socorro Landeros</p>
                      </div>
                    </div>
                  </div>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="">Mtra. Gpe. Laura Ramírez Juárez</p>
                      </div>
                    </div>
                  </div>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="">Lic. Adriana Cuéllar Hernández</p>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
            <!-- Fin del panel Generación de contenidos -->
            <!-- Inicio del panel Implementación Web: desarrollo, diseño y actualización -->
            <div class="columns is-centered">
              <div class="column is-two-thirds is-full-mobile">
                <article class="panel">
                  <p class="panel-heading primary-background">
                    Implementación Web: desarrollo, diseño y actualización
                  </p>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="">Ing. Michelle Caterine García Velasco</p>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
            <!-- Fin del panel Implementación Web: desarrollo, diseño y actualización -->
            <!-- Inicio del panel Imágenes -->
            <div class="columns is-centered">
              <div class="column is-two-thirds is-full-mobile">
                <article class="panel">
                  <p class="panel-heading primary-background">
                    Imágenes
                  </p>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="">
                          <a
                            target="_blanck"
                            href="https://www.freepik.com/"
                          >
                            Creador de imagenes d3images en freepik
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="">
                          <a
                            target="_blanck"
                            href='https://www.freepik.com/'
                          >
                            Creador de imagenes pch.vector en freepik
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="panel-block is-active">
                    <div class="columns is-centered is-full">
                      <div class="column is-full">
                        <p class="">
                          <a
                            target="_blanck"
                            href='https://www.freepik.com/'
                          >
                            Creador de imagenes stories en freepik
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
            <!-- Fin del panel Imágenes -->
          </div>
          <!-- FIN DE COLUMNA REAL DE CRÉDITOS -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Credits',
  data: () => ({
    activeMenu: false,
  }),
  /*
  methods: {
    inactiveMenu() {
      console.log('hola');
    },
  },
  */
};
</script>
<style lang="scss">
  @import '@/assets/styles/colors.scss';
  .is-full{
    width: 100%;
  }
  .panel-block{
    line-height: 1.2;
  }
  .panel-block a:hover {
    color: $link-hover;
  }
</style>
